import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { StudioSessionStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('studio-session', reducer),
        EffectsModule.forFeature([StudioSessionStoreEffects]),
    ],
    providers: [],
})
export class StudioSessionStoreModule { }
